import * as React from 'react';
import { Heading, List, ListItem, Stack, Text } from '@origin-digital/ods-core';

export const BattStarterEligibilityCriteriaModal = (
  <Stack data-id="plan-key-details-info-modal">
    <Heading variant="h3">Confirm your eligibility</Heading>
    <Stack space="xxsmall">
      <Text weight="medium">To be eligible for this Energy Plan:</Text>
      <List space="xxsmall">
        <ListItem>
          <Text variant="body-small">your solar PV system must be net metered</Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            your solar PV system must not exceed 50KW of inverter capacity or must be limited to
            50KW of export
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            you must not be receiving a feed-in tariff under any government scheme.
          </Text>
        </ListItem>
      </List>
    </Stack>
  </Stack>
);
